
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <div class="text-center mb-4">
            <h4 class="fw-bold ">Reset new password</h4>
          </div>
          <form [formGroup]="resetPasswordForm" (ngSubmit)="submit()" novalidate>
            <input type="hidden" formControlName="code">
            <div class="form-group mb-3">
              <label class="form-label" for="email">Your email</label>
              <input type="email" class="form-control" MyInput placeholder="Email" formControlName="email" id="email">
              <my-error controlName="email" errorKey="required">Email is required.</my-error>
              <my-error controlName="email" errorKey="email">Please enter a valid email.</my-error>
            </div>
            <div class="form-group mb-3">
              <label class="form-label" for="password">Password</label>
              <input type="password" class="form-control" MyInput placeholder="Password" formControlName="password"
                id="password">
              <my-error controlName="password" errorKey="required">Password is required.</my-error>
              <my-error controlName="password" errorKey="minlength">Password must be at least 6 characters.
              </my-error>
            </div>
            <div class="form-group mb-3">
              <label class="form-label" for="confirmPassword">Confirm Password</label>
              <input type="password" class="form-control" MyInput placeholder="Confirm Password"
                formControlName="confirmPassword" id="confirmPassword">
              <my-error controlName="confirmPassword" errorKey="required">Confirm Password is required.</my-error>
              <div class="invalid-feedback" style="display: block;"
                *ngIf="resetPasswordForm.get('confirmPassword').dirty && resetPasswordForm.hasError('mismatch')">
                Confirm password must match password
              </div>
            </div>
            <button class="btn btn-primary btn-lg btn-block mt-3" [disabled]="!resetPasswordForm.valid || loading"
              type="submit">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
              Reset Password
            </button>
          </form>
        </div>
      </div>